import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { QuoteManualDetailedModel } from '@data-layer/models/lcl';
import { enumManualQuoteState } from '@data-layer/enums/lcl';

@Component({
  selector: 'mobile-lcl-manual-quote-card',
  templateUrl: './mobile-lcl-manual-quote-card.component.html',
  styleUrls: ['./mobile-lcl-manual-quote-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileLclManualQuoteCardComponent {
  @Input() public quote: QuoteManualDetailedModel;

  public KG_TON_MULTIPLIER: number = 1000;

  constructor() {}

  public get currentStatusText(): string {
    switch (this.quote?.status) {
      case enumManualQuoteState.NEW:
      case enumManualQuoteState.HANDLING:
      case enumManualQuoteState.QUOTED:
        return 'WAITING_FOR_OFFERS';

      case enumManualQuoteState.DENIED:
        return 'WAITING_FOR_OFFERS_DENIED';

      default:
        return 'WAITING_FOR_OFFERS';
    }
  }

  public get isDenied(): boolean {
    return this.quote?.status === enumManualQuoteState.DENIED;
  }
}
